import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-6" }
const _hoisted_2 = { class: "d-flex align-center mb-2" }
const _hoisted_3 = {
  key: 0,
  class: "text-caption text-medium-emphasis ml-3 font-italic"
}
const _hoisted_4 = { class: "mb-6" }
const _hoisted_5 = { class: "d-flex align-center mb-2" }
const _hoisted_6 = {
  key: 0,
  class: "text-caption text-medium-emphasis ml-3 font-italic"
}
const _hoisted_7 = { class: "mb-6" }
const _hoisted_8 = { class: "d-flex align-center mb-2" }
const _hoisted_9 = {
  key: 0,
  class: "text-caption text-medium-emphasis ml-3 font-italic"
}
const _hoisted_10 = { class: "mb-2" }
const _hoisted_11 = { class: "d-flex align-center mb-2" }
const _hoisted_12 = {
  key: 0,
  class: "text-caption text-medium-emphasis ml-3 font-italic"
}
const _hoisted_13 = { class: "text-h6 font-weight-bold" }
const _hoisted_14 = {
  key: 0,
  class: "d-flex justify-center mb-4"
}

import { ref, onMounted } from 'vue';
import axios from 'axios';
import { Chart as highcharts } from 'highcharts-vue';

// Importación de constantes y utilidades
import { TOKEN } from '@/constants/labels';
import { APIS_SQLLITE_REPORT, TIMEOUTTIME } from '@/constants/apis';
import { showConsoleError } from '@/functions/errors';

// Estados reactivos

export default /*@__PURE__*/_defineComponent({
  __name: 'ServerView',
  setup(__props) {

const dialogHistorico = ref(false);
const equipoSeleccionado = ref('');
const tipoTablaActual = ref('');
const metricaVmSeleccionada = ref<'disco' | 'cpu' | 'ram'>('disco');
const datosHistoricosGuardados = ref<any[]>([]);

const showError = ref(false);
const showServer = ref(false);

// Variable para la hora global de última extracción de la DB
const ultimaActualizacion = ref('');

// Datos de tablas
const extractionRunsData = ref([]);
const hostsData = ref([]);
const datastoresData = ref<any[]>([]);
const vmsData = ref([]);
const alarmsData = ref([]);

const configHeader = { 
  timeout: TIMEOUTTIME, 
  headers: { "Authorization": `Bearer ${TOKEN}` } 
};

// Configuración predeterminada del gráfico Estándar
const chartOptions = ref<any>({
  chart: { type: 'line', backgroundColor: 'transparent' },
  title: { text: '' },
  xAxis: { categories: [] },
  yAxis: { title: { text: 'Valor' } },
  series: []
});

// Headers para Vuetify Data Tables
const headersHosts = ref([
  { title: 'Nombre / IP', key: 'nombre' },
  { title: 'Estado', key: 'estado' },
  { title: 'Condición', key: 'condicion' },
  { title: 'Clúster', key: 'cluster' },
  { title: '% CPU', key: 'cpu_pct' },
  { title: '% Memoria', key: 'mem_pct' },
  { title: 'Estado HA', key: 'ha_estado' },
  { title: 'Uptime', key: 'uptime' }
]);

const headersDatastores = ref([
  { title: 'Nombre', key: 'nombre' },
  { title: 'Condición', key: 'condicion' },
  { title: 'Tipo', key: 'tipo' },
  { title: 'Capacidad (TB)', key: 'capacidad_tb' },
  { title: 'Libre (TB)', key: 'libre_tb' }
]);

const headersVms = ref([
  { title: 'Nombre VM', key: 'nombre' },
  { title: 'Estado', key: 'estado' },
  { title: 'Condición', key: 'condicion' },
  { title: 'Aprovisionado (GB)', key: 'prov_gb' },
  { title: 'Usado (GB)', key: 'usado_gb' },
  { title: 'CPU (MHz)', key: 'cpu_mhz' },
  { title: 'RAM (MB)', key: 'mem_mb' }
]);

const headersAlarms = ref([
  { title: 'Alarma', key: 'alarma' },
  { title: 'Objeto Afectado', key: 'objeto' },
  { title: 'Tipo de Objeto', key: 'tipo_objeto' },
  { title: 'Gravedad', key: 'gravedad' }
]);

/**
 * Función auxiliar para formatear la fecha a DD/MM HH:mm
 */
function formatearFechaHora(timestamp: string | Date) {
  if (!timestamp) return '';
  const d = new Date(timestamp);
  if (isNaN(d.getTime())) return String(timestamp);

  const dia = String(d.getDate()).padStart(2, '0');
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  const hora = String(d.getHours()).padStart(2, '0');
  const minutos = String(d.getMinutes()).padStart(2, '0');
  return `${dia}/${mes} ${hora}:${minutos}`;
}

/**
 * Petición inicial de datos generales
 */
async function getAllServerData() {
  showError.value = false;
  showServer.value = false;

  try {
    const [resRuns, resHosts, resDatastores, resVms, resAlarms] = await Promise.all([
      axios.get(APIS_SQLLITE_REPORT.value.getExtractionRuns, configHeader),
      axios.get(APIS_SQLLITE_REPORT.value.getHosts, configHeader),
      axios.get(APIS_SQLLITE_REPORT.value.getDatastores, configHeader),
      axios.get(APIS_SQLLITE_REPORT.value.getVms, configHeader),
      axios.get(APIS_SQLLITE_REPORT.value.getAlarms, configHeader)
    ]);

    extractionRunsData.value = resRuns.data.data;
    hostsData.value = resHosts.data.data;
    datastoresData.value = resDatastores.data.data;
    vmsData.value = resVms.data.data;
    alarmsData.value = resAlarms.data.data;

    // Extrae la última hora de extracción registrada en la base de datos
    if (resRuns.data.data && resRuns.data.data.length > 0) {
      const ultimoRun = resRuns.data.data[0];
      const campoFecha = ultimoRun.timestamp || ultimoRun.created_at || ultimoRun.fecha;
      ultimaActualizacion.value = formatearFechaHora(campoFecha);
    }

    showServer.value = true;
  } catch (error) {
    showError.value = true;
    showServer.value = false;
    showConsoleError(error);
  }
}

/**
 * Consulta el histórico según la fila seleccionada
 */
async function abrirHistorico(row: any, tabla: string) {
  const dataFila = row.item ? row.item : row;
  const identificador = dataFila.nombre || dataFila.ip || dataFila.objeto;

  if (!identificador) return;

  equipoSeleccionado.value = identificador;
  tipoTablaActual.value = tabla;
  metricaVmSeleccionada.value = 'disco';

  try {
    const res = await axios.get(APIS_SQLLITE_REPORT.value.getHistorico, {
      params: { 
        tabla, 
        identificador,
        _t: new Date().getTime()
      },
      headers: { "Authorization": `Bearer ${TOKEN}` },
      timeout: TIMEOUTTIME
    });

    datosHistoricosGuardados.value = res.data.data || [];

    if (tabla === 'vms') {
      actualizarGraficoVM();
    } else {
      construirGraficoGeneral(tabla);
    }

    dialogHistorico.value = true;
  } catch (error) {
    showConsoleError(error);
  }
}

/**
 * Procesa categorías y series para Hosts y Datastores
 */
function construirGraficoGeneral(tabla: string) {
  const datos = datosHistoricosGuardados.value;

  const categoriasFechas = datos.map((item: any) => formatearFechaHora(item.timestamp));

  let series: any[] = [];
  let tituloY = '';

  if (tabla === 'hosts') {
    tituloY = 'Porcentaje (%)';
    series = [
      { name: '% CPU', data: datos.map((i) => i.cpu_pct), color: '#1E88E5' },
      { name: '% Memoria', data: datos.map((i) => i.mem_pct), color: '#FB8C00' }
    ];
  } else if (tabla === 'datastores') {
    tituloY = 'Terabytes (TB)';
    series = [
      { name: 'Capacidad Total (TB)', data: datos.map((i) => i.capacidad_tb), color: '#2196F3' },
      { name: 'Espacio Libre (TB)', data: datos.map((i) => i.libre_tb), color: '#4CAF50' }
    ];
  }

  chartOptions.value = {
    chart: { type: 'line', backgroundColor: 'transparent' },
    title: { text: `Rendimiento: ${equipoSeleccionado.value}` },
    xAxis: { categories: categoriasFechas },
    yAxis: { title: { text: tituloY } },
    series
  };
}

/**
 * Conmuta entre Disco, CPU y RAM cuando la tabla seleccionada es de Máquinas Virtuales
 */
function actualizarGraficoVM() {
  const datos = datosHistoricosGuardados.value;

  const categoriasFechas = datos.map((item: any) => formatearFechaHora(item.timestamp));

  let series: any[] = [];
  let tituloY = '';

  if (metricaVmSeleccionada.value === 'disco') {
    tituloY = 'Gigabytes (GB)';
    series = [
      { name: 'Aprovisionado (GB)', data: datos.map((i) => i.prov_gb), color: '#9C27B0' },
      { name: 'Usado (GB)', data: datos.map((i) => i.usado_gb), color: '#F44336' }
    ];
  } else if (metricaVmSeleccionada.value === 'cpu') {
    tituloY = 'Megahertz (MHz)';
    series = [
      { name: 'Uso CPU (MHz)', data: datos.map((i) => i.cpu_mhz), color: '#00BCD4' }
    ];
  } else if (metricaVmSeleccionada.value === 'ram') {
    tituloY = 'Megabytes (MB)';
    series = [
      { name: 'Uso RAM (MB)', data: datos.map((i) => i.mem_mb), color: '#E91E63' }
    ];
  }

  chartOptions.value = {
    chart: { type: 'line', backgroundColor: 'transparent' },
    title: { text: `VM: ${equipoSeleccionado.value}` },
    xAxis: { categories: categoriasFechas },
    yAxis: { title: { text: tituloY } },
    series
  };
}

// Helpers de estilo
const getCondicionColor = (condicion: string) => {
  if (!condicion) return 'default';
  const val = condicion.toLowerCase();
  if (val === 'normal') return 'success';
  if (val === 'crítico' || val === 'critico') return 'error';
  return 'warning';
};

const getGravedadColor = (gravedad: string) => {
  if (!gravedad) return 'default';
  const val = gravedad.toUpperCase();
  if (val === 'CRÍTICA' || val === 'CRITICA') return 'error';
  if (val === 'ADVERTENCIA' || val === 'WARNING') return 'warning';
  return 'info';
};

onMounted(() => {
  getAllServerData();
});

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_sheet, {
      color: "bgtopology",
      class: "defaultCard"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "text-h6 font-weight-bold" }, "1. Estado de Servidores", -1)),
            (ultimaActualizacion.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, " (" + _toDisplayString(ultimaActualizacion.value) + ") ", 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_v_data_table, {
            headers: headersHosts.value,
            items: hostsData.value,
            density: "compact",
            class: "elevation-1 cursor-pointer",
            "no-data-text": "No hay servidores disponibles",
            "onClick:row": _cache[0] || (_cache[0] = (event, row) => abrirHistorico(row, 'hosts'))
          }, {
            "item.condicion": _withCtx(({ item }) => [
              _createVNode(_component_v_chip, {
                color: getCondicionColor(item.condicion),
                size: "small",
                label: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.condicion), 1)
                ]),
                _: 2
              }, 1032, ["color"])
            ]),
            "item.cpu_pct": _withCtx(({ item }) => [
              _createTextVNode(_toDisplayString(item.cpu_pct) + "%", 1)
            ]),
            "item.mem_pct": _withCtx(({ item }) => [
              _createTextVNode(_toDisplayString(item.mem_pct) + "%", 1)
            ]),
            _: 1
          }, 8, ["headers", "items"])
        ]),
        _createVNode(_component_v_divider, { class: "my-4" }),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "text-h6 font-weight-bold" }, "2. Datastores", -1)),
            (ultimaActualizacion.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, " (" + _toDisplayString(ultimaActualizacion.value) + ") ", 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_v_data_table, {
            headers: headersDatastores.value,
            items: datastoresData.value,
            density: "compact",
            class: "elevation-1 cursor-pointer",
            "no-data-text": "No hay datastores disponibles",
            "onClick:row": _cache[1] || (_cache[1] = (event, row) => abrirHistorico(row, 'datastores'))
          }, {
            "item.condicion": _withCtx(({ item }) => [
              _createVNode(_component_v_chip, {
                color: getCondicionColor(item.condicion),
                size: "small",
                label: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.condicion), 1)
                ]),
                _: 2
              }, 1032, ["color"])
            ]),
            "item.capacidad_tb": _withCtx(({ item }) => [
              _createTextVNode(_toDisplayString(item.capacidad_tb) + " TB", 1)
            ]),
            "item.libre_tb": _withCtx(({ item }) => [
              _createTextVNode(_toDisplayString(item.libre_tb) + " TB", 1)
            ]),
            _: 1
          }, 8, ["headers", "items"])
        ]),
        _createVNode(_component_v_divider, { class: "my-4" }),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "text-h6 font-weight-bold" }, "3. Máquinas Virtuales (VMs)", -1)),
            (ultimaActualizacion.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, " (" + _toDisplayString(ultimaActualizacion.value) + ") ", 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_v_data_table, {
            headers: headersVms.value,
            items: vmsData.value,
            density: "compact",
            class: "elevation-1 cursor-pointer",
            "no-data-text": "No hay máquinas virtuales disponibles",
            "onClick:row": _cache[2] || (_cache[2] = (event, row) => abrirHistorico(row, 'vms'))
          }, {
            "item.estado": _withCtx(({ item }) => [
              _createVNode(_component_v_chip, {
                color: item.estado === 'Encendido' ? 'success' : 'grey',
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.estado), 1)
                ]),
                _: 2
              }, 1032, ["color"])
            ]),
            "item.prov_gb": _withCtx(({ item }) => [
              _createTextVNode(_toDisplayString(item.prov_gb) + " GB", 1)
            ]),
            "item.usado_gb": _withCtx(({ item }) => [
              _createTextVNode(_toDisplayString(item.usado_gb) + " GB", 1)
            ]),
            _: 1
          }, 8, ["headers", "items"])
        ]),
        _createVNode(_component_v_divider, { class: "my-4" }),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "text-h6 font-weight-bold text-error" }, "4. Alarmas Activas", -1)),
            (ultimaActualizacion.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, " (" + _toDisplayString(ultimaActualizacion.value) + ") ", 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_v_data_table, {
            headers: headersAlarms.value,
            items: alarmsData.value,
            density: "compact",
            class: "elevation-1 cursor-pointer",
            "no-data-text": "Sin alarmas activas"
          }, {
            "item.gravedad": _withCtx(({ item }) => [
              _createVNode(_component_v_chip, {
                color: getGravedadColor(item.gravedad),
                size: "small",
                class: "font-weight-bold"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.gravedad), 1)
                ]),
                _: 2
              }, 1032, ["color"])
            ]),
            _: 1
          }, 8, ["headers", "items"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: dialogHistorico.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dialogHistorico).value = $event)),
      "max-width": "850px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { color: "bgtopology" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "d-flex justify-space-between align-center" }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_13, " Histórico: " + _toDisplayString(equipoSeleccionado.value), 1),
                _createVNode(_component_v_btn, {
                  icon: "mdi-close",
                  variant: "text",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (dialogHistorico.value = false))
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                (tipoTablaActual.value === 'vms')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createVNode(_component_v_btn_toggle, {
                        modelValue: metricaVmSeleccionada.value,
                        "onUpdate:modelValue": [
                          _cache[4] || (_cache[4] = ($event: any) => ((metricaVmSeleccionada).value = $event)),
                          actualizarGraficoVM
                        ],
                        mandatory: "",
                        color: "primary",
                        variant: "outlined",
                        density: "comfortable"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            value: "disco",
                            "prepend-icon": "mdi-harddisk"
                          }, {
                            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                              _createTextVNode("Disco (GB)", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_btn, {
                            value: "cpu",
                            "prepend-icon": "mdi-cpu-64-bit"
                          }, {
                            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                              _createTextVNode("CPU (MHz)", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_btn, {
                            value: "ram",
                            "prepend-icon": "mdi-memory"
                          }, {
                            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                              _createTextVNode("RAM (MB)", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_unref(highcharts), { options: chartOptions.value }, null, 8, ["options"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})